import "./Navbar.css";

export default function NavbarTemplate({ scrolled, navLinks, onNavClick, onCtaClick }) {
  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <div className="navbar__inner">

        <div className="navbar__logo" onClick={() => onNavClick({ id: "hero" })}>
          <div className="navbar__logo-icon">⚡</div>
          <span className="navbar__logo-text">
            QuickWork<span className="navbar__logo-accent">.ro</span>
          </span>
        </div>

        <div className="navbar__links mobile-hide">
          {navLinks.map((link) => (
            <button key={link.id} className="nav-link" onClick={() => onNavClick(link)}>
              {link.label}
            </button>
          ))}
        </div>

        <button className="btn-primary navbar__cta mobile-hide" onClick={onCtaClick}>
          Audit gratuit →
        </button>

      </div>
    </nav>
  );
}
